module.exports = __webpack_public_path__ + "static/media/tag.5f93a783.svg";